'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function createQueryParamString(paramObject) {
  return Object.keys(paramObject).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(paramObject[key]);
  }).join('&');
}

exports.default = createQueryParamString;
module.exports = exports['default'];